import { cn } from "@/lib/utils";

type StatusTone = "live" | "amber" | "muted" | "destructive" | null;

const TONE_BG: Record<Exclude<StatusTone, null>, string> = {
	live: "bg-green-500",
	amber: "bg-amber-500",
	muted: "bg-muted-foreground/40",
	destructive: "bg-destructive",
};

// `tone === null` means "healthy / active" — we render a transparent
// placeholder of the same size so rows that mix healthy/unhealthy items
// stay aligned. Returning `null` would let the leading element shift
// horizontally when an item flips state.
export function StatusDot({ tone }: { tone: StatusTone }) {
	return (
		<span
			aria-hidden={tone === null}
			className={cn(
				"h-1.5 w-1.5 shrink-0 rounded-full",
				tone === null ? "bg-transparent" : TONE_BG[tone],
			)}
		/>
	);
}
